import { LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'

export const InitialPage = observer(() => {
  return (
    <div className="page-container mobile-m-0">
      <LoadingSpinner />
    </div>
  )
})
